export default function initToggle() {
    const toggleElem = document.querySelectorAll('[data-toggle-aria]');

    toggleElem.forEach((element) => {
        const ariaControls = element.getAttribute('aria-controls');
        const ariaControlsElement = document.querySelector(`#${ariaControls}`);

        element.addEventListener('click', (event) => {
            event.preventDefault();

            if (ariaControlsElement.getAttribute('aria-hidden') === 'false') {
                element.setAttribute('aria-expanded', false);
                ariaControlsElement.setAttribute('aria-hidden', true);

                // Toggle aria expanded for all the related controls
                if (element.getAttribute('aria-controls') === 'aside') {
                    const asideAriaControlsElements = document.querySelectorAll('[aria-controls="aside"]');
                    asideAriaControlsElements.forEach((asideAriaControlsElement) => {
                        asideAriaControlsElement.setAttribute('aria-expanded', false);
                    });
                }

                // Toggle tabindex for menu controls / items
                const tabToggleElements = document.querySelectorAll('[data-tabindex-visible]');
                tabToggleElements.forEach((tabToggleElement) => {
                    tabToggleElement.setAttribute('tabindex', '-1');
                });

                // Toggle faq accordion aria-label
                if (element.classList.contains('faq-question')) {
                    element.querySelector('svg').setAttribute('aria-label', 'Toon info');
                }
            } else {
                element.setAttribute('aria-expanded', true);
                ariaControlsElement.setAttribute('aria-hidden', false);

                const focusableElement = ariaControlsElement.querySelector('[aria-focus]');
                if (document.contains(focusableElement)) {
                    focusableElement.focus({ preventScroll: false });
                }

                // Toggle aria expanded for all the related controls
                if (element.getAttribute('aria-controls') === 'aside') {
                    const asideAriaControlsElements = document.querySelectorAll('[aria-controls="aside"]');
                    asideAriaControlsElements.forEach((asideAriaControlsElement) => {
                        asideAriaControlsElement.setAttribute('aria-expanded', true);
                    });
                }

                // Toggle tabindex for menu controls / items
                const tabToggleElements = document.querySelectorAll('[data-tabindex-visible]');
                tabToggleElements.forEach((tabToggleElement) => {
                    tabToggleElement.setAttribute('tabindex', tabToggleElement.getAttribute('data-tabindex-visible'));
                });

                // Toggle faq accordion aria-label
                if (element.classList.contains('faq-question')) {
                    element.querySelector('svg').setAttribute('aria-label', 'Verberg info');
                }
            }
        });

        // When navigating with keyboard over the close button, close the menu
        element.addEventListener('keydown', (e) => {
            if (e.key === 'Tab'
                && e.currentTarget.querySelector('svg').getAttribute('aria-label') === 'Menu sluiten'
                && document.getElementById('aside').getAttribute('aria-hidden') === 'false') {
                e.currentTarget.click();
            }
        });
    });
}
